import React from 'react';
import { WarehouseIcon, BadgeDollarSignIcon, SearchIcon, ShieldCheckIcon } from 'lucide-react';
export function WhyChoosePES() {
  return <section id="why-pes" className="relative w-full py-16 md:py-24" aria-labelledby="why-heading" data-id="element-291">
      {/* Parallax Background */}
      <div className="parallax-bg absolute inset-0 z-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/8oCZQuD3ay2oGoJdVYZ2iA/tmpjeg2ihsu.jpg)'
    }} aria-hidden="true" data-id="element-292" />
      <div className="absolute inset-0 z-[1] bg-black/80" aria-hidden="true" data-id="element-293" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16" data-id="element-295">
          <h2 id="why-heading" className="font-oswald font-bold text-[28px] sm:text-3xl md:text-4xl lg:text-5xl uppercase tracking-wide text-white mb-4" data-id="element-296">
            Why Choose PES
          </h2>
          <p className="text-brand-muted text-base md:text-lg max-w-2xl mx-auto" data-id="element-297">
            We're not just another dealer. Here's what sets Payne Equipment
            Sales apart.
          </p>
        </div>

        {/* 4 Pillars */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-298">
          {/* Pillar 1 */}
          <div className="text-center" data-id="element-299">
            <div className="w-16 h-16 rounded-full bg-brand-orange/15 flex items-center justify-center mx-auto mb-5" data-id="element-300">
              <WarehouseIcon className="w-8 h-8 text-brand-orange" aria-hidden="true" data-id="element-301" />
            </div>
            <h3 className="font-oswald font-semibold text-lg uppercase text-white mb-3" data-id="element-302">
              Arizona's Largest Dealer
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-303">
              Hundreds of machines in stock at our Peoria yard. If we don't have
              it, we'll find it.
            </p>
          </div>

          {/* Pillar 2 */}
          <div className="text-center" data-id="element-304">
            <div className="w-16 h-16 rounded-full bg-brand-orange/15 flex items-center justify-center mx-auto mb-5" data-id="element-305">
              <BadgeDollarSignIcon className="w-8 h-8 text-brand-orange" aria-hidden="true" data-id="element-306" />
            </div>
            <h3 className="font-oswald font-semibold text-lg uppercase text-white mb-3" data-id="element-307">
              Financing 12–60 Months
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-308">
              Flexible financing options to fit your budget. Get approved fast
              and get to work.
            </p>
          </div>

          {/* Pillar 3 */}
          <div className="text-center" data-id="element-309">
            <div className="w-16 h-16 rounded-full bg-brand-orange/15 flex items-center justify-center mx-auto mb-5" data-id="element-310">
              <SearchIcon className="w-8 h-8 text-brand-orange" aria-hidden="true" data-id="element-311" />
            </div>
            <h3 className="font-oswald font-semibold text-lg uppercase text-white mb-3" data-id="element-312">
              We'll Find It for You
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-313">
              Need something specific? Our network spans the country. Tell us
              what you need.
            </p>
          </div>

          {/* Pillar 4 */}
          <div className="text-center" data-id="element-314">
            <div className="w-16 h-16 rounded-full bg-brand-orange/15 flex items-center justify-center mx-auto mb-5" data-id="element-315">
              <ShieldCheckIcon className="w-8 h-8 text-brand-orange" aria-hidden="true" data-id="element-316" />
            </div>
            <h3 className="font-oswald font-semibold text-lg uppercase text-white mb-3" data-id="element-317">
              Honest & Transparent
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-318">
              No hidden fees, no games. What you see is what you get — every
              single time.
            </p>
          </div>
        </div>
      </div>
    </section>;
}